import { render, staticRenderFns } from "./SignInIrisGlobal.vue?vue&type=template&id=72f87984&scoped=true&"
import script from "./SignInIrisGlobal.vue?vue&type=script&lang=js&"
export * from "./SignInIrisGlobal.vue?vue&type=script&lang=js&"
import style0 from "./SignInIrisGlobal.vue?vue&type=style&index=0&id=72f87984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f87984",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardText,VForm,VIcon,VImg,VProgressLinear,VTextField})
